import Controller from "./accordionItem.controller";
import template from "./accordionItem.html";

const accordionItem = {
  template,
  controller: Controller,
  bindings: {
    accordionTitle: "@",
    defaultOpened: "<",
  },
  transclude: true,
  require: {
    $groupCtrl: "^?accordionGroup",
  },
};

export default accordionItem;



// WEBPACK FOOTER //
// ./src/components/accordionItem/accordionItem.component.js